import { Dialog } from "primereact/dialog";

import { SummaryLogsProps } from "./summaryLogsConsts";
import { TransferLogs } from "../../../../lich-su-truyen-nhan/component/TransferLogs";
import { convertDataPeriod } from "../../invoiceSummaryUtils";
import { ODataPeriod } from "../../../../../shared/constants";
import moment from "moment";
import { useTranslation } from "../../../../../shared/language";

export const SummaryLog = ({
  open,
  onHide,
  invoiceSummaryData,
}: SummaryLogsProps) => {
  const { t } = useTranslation();
  return (
    <Dialog
      header={`${t("report.summaryTransferHistory")}. ${t("report.summaryNumber")}: ${
        invoiceSummaryData?.summaryDataNumber
      }. ${t("report.dataPeriod")}: ${convertDataPeriod(invoiceSummaryData?.dataPeriod)} ${
        invoiceSummaryData?.dataPeriod !== ODataPeriod.DAY
          ? `${invoiceSummaryData?.monthOrQuarter} ${t("report.year")} ${invoiceSummaryData?.year}`
          : ""
      }${
        invoiceSummaryData?.dataPeriod === ODataPeriod.DAY
          ? `${moment(invoiceSummaryData.dataPeriodDate).format("DD/MM/YYYY")}`
          : ""
      }
        `}
      onHide={onHide}
      visible={open}
      style={{ maxWidth: "1000px", width: "100%" }}
    >
      {open && invoiceSummaryData && (
        <TransferLogs type='Summary' idAction={invoiceSummaryData.id} />
      )}
    </Dialog>
  );
};
